<template>
  <audio v-if="shouldRender" preload="none" controls="" :src="audioSrc" type="audio/mpeg" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { getFullPathForPublicAssets } from '@/utils/url';
import { requestAudioRendering } from '@/utils/safariAudioHack';

const props = defineProps({ src: { type: String, required: true } });

// if prefixed with /audio it's a relative asset
const audioSrc = computed(() => (props.src.startsWith('/audio') ? getFullPathForPublicAssets(props.src) : props.src));

const shouldRender = ref(false);

requestAudioRendering(() => {
  shouldRender.value = true;
});
</script>

<style scoped lang="scss"></style>
